<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-syringe'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption">{{ printName }}</v-list-item-subtitle>
      <v-list-item-title>{{ printStatus }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="secondary" v-bind="attrs" v-on="on" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.status"
          label="現在または過去において、呼吸器性疾患、精神・神経性疾患および心臓病などの重症病にかかり、医師の治療または投薬を受けたことがありますか?"
          :rules="rules.status"
          @change="changed">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes || isFormStatusPast">
        <v-text-field
          v-model="form.name"
          label="病名"
          :rules="rules.name"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsMedical',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'medical'
      },
      form: {
        id: '',
        status: '',
        name: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        name: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          name: dt.name ? dt.name : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          name: this.$props.data.name ? this.$props.data.name : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('medical_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    changed: function () {
      this.prepare({
        id: '' + (this.$props.data.id ? this.$props.data.id : ''),
        status: this.form.status ? this.form.status : ''
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('medical_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('medical_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('medical_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$mango.about.medical.status[this.$props.data.status]
      ) ? this.$mango.about.medical.status[this.$props.data.status] : '既往症の回答'
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'YES'
      )
    },
    isStatusPast () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'PAST'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    isFormStatusPast () {
      return !!(
        this.form.status === 'PAST'
      )
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name
      ) ? this.$props.data.name : ''
    },
    getStatusItems () {
      return this.$mango.about.medical.status
    }
  }
}
</script>
